import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, switchMap } from 'rxjs';
import { SessionService } from 'src/app/auth/session.service';
import { NotificationContextAttributesService } from 'src/app/notifications/notifications-context-attributes.service';
import { NotificationService } from 'src/app/notifications/notifications.service';
import { IDeactivate } from './save-data.interface';

@Injectable({
  providedIn: 'root',
})
export class SaveDataGuard {
  private notificationService = inject(NotificationService);
  private notificationContextService = inject(NotificationContextAttributesService);
  private modalService = inject(NgbModal);
  private sessionService = inject(SessionService);

  public canDeactivate(component: IDeactivate): Observable<boolean> {
    this.unsubscribeInputFieldsFocus();
    return this.showNotification(component);
  }

  private showNotification(component: IDeactivate): Observable<boolean> {
    if (component.isFormChanged && this.sessionService.isSessionActive()) {
      return this.notificationService
        .dialogSaveData({
          title: 'EXIT_NOTIFICATION_TITLE',
          description: 'EXIT_NOTIFICATION_DESCRIPTION',
          buttons: this.notificationContextService.getExitButtons(),
        })
        .pipe(
          switchMap((value: boolean) => {
            if (value) {
              if (component.setDefaultValueForModal) {
                component.setDefaultValueForModal();
              }
              this.modalService.dismissAll();
              return of(true);
            }
            return of(false);
          }),
        );
    }
    if (component.setDefaultValueForModal) {
      component.setDefaultValueForModal();
    }
    return of(true);
  }

  private unsubscribeInputFieldsFocus(): void {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
}
